import React, { useEffect, useState } from "react";
import "./_user.scss";
import DashboardSideBar from "./DashboardSideBar";
import { Table } from 'antd';
import axios from "axios";
const columns = [
  {
    title: "Identifier",
    dataIndex: "Email",
    key: "email",
  },
  {
    title: "Created",
    dataIndex: "Creation Time",
    key: "creationTime",
    render: (timestamp) => new Date(timestamp).toLocaleString(), // Format the timestamp
  },
  {
    title: "Signed in",
    dataIndex: "Last Sign-In Time",
    key: "lastSignInTime",
    render: (timestamp) => new Date(timestamp).toLocaleString(), // Format the timestamp
  },
  {
    title: "User UID",
    dataIndex: "UID",
    key: "uid",
  },
];

const User = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get("https://nexgenbackend.octalooptechnologies.com/get-users");
        if (response.data && response.data.data) {
          setUsers(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);
  return (
    <DashboardSideBar>
      <div className="w-100">
        <div className="d-flex">
          <div className="users w-100">
            <div className="main">
              <div className="text-center mt-5 mb-3">
                <h1>Users</h1>
                <p className="opacity-50">
                This Section show the User Information.
                </p>
              </div>
              <div>
                {/* antd table  */}
              <div className="user-table">
              <Table columns={columns}  dataSource={users}
                  rowKey="UID"  pagination={{ pageSize: 5 }}   loading={loading} />
              </div>
              </div>
             
            </div>

           
          </div>
        </div>
      </div>
    </DashboardSideBar>
  );
};

export default User;
